import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import DeactivationModal from 'components/DeactivationModals/DeactivationModal';
import DetailsRefusalModal from 'components/DetailsRefusalModal/DetailsRefusalModal';
import Loader from 'components/Loader/Loader';
import StakeholderCard from 'components/StakeholderCard/StakeholderCard';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IMaterialityAssessmentStakeholderView from './interfaces/IMaterialityAssessmentStakeholderView';

import styles from './scss/MaterialityAssessmentStakeholder.module.scss';

function MaterialityAssessmentStakeholderView({
  selectedStakeholders,
  isUserLoading,
  onCheckStakeholder,
  onHandleNext,
  openModalRefused,
  onRejectModal,
  onSubmitModal,
  openModalDetailsRefusal,
  onCloseModalDetailsRefusal,
  userData,
  currentId,
  onClickStakeholder,
  onClickStakeholderTitle,
  onPrevious,
  mainVcTabs,
  handleClickVcTab,
  activeVcTab,
  isViewOnly = false,
}: IMaterialityAssessmentStakeholderView) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.tabs}>
        {mainVcTabs.map((item) => (
          <Button
            key={[item.id, item.name].join('-')}
            title={item.name}
            variant={BUTTON_VARIANT.ghost}
            onClick={() => handleClickVcTab(item.id)}
            className={clsx(styles.tab, { [styles.active]: activeVcTab === item.id })}
          />
        ))}
      </div>
      <span className={styles.header}>{t('materialityAssessment.stakeholderIdentification')}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />
          <div className={clsx(styles.contentWrapper, { [styles.loaderWrapper]: isUserLoading })}>
            {isUserLoading ? (
              <Loader isPageLoading={isUserLoading} isFullLoader={false} classNameLoader={styles.loaderContent} />
            ) : (
              selectedStakeholders?.length > 0 && selectedStakeholders?.map((stakeholder) => (
                <StakeholderCard
                  key={stakeholder.type}
                  id={stakeholder.type}
                  title={stakeholder.type}
                  checked={stakeholder.isActive}
                  onCheck={onCheckStakeholder}
                  onClickTitle={onClickStakeholderTitle}
                  clickBtn={onClickStakeholder}
                  status={stakeholder.status}
                  hasRefusalDetails={!stakeholder.isActive && Boolean(stakeholder.deactivationReason)}
                  isViewOnly={isViewOnly}
                />
              ))
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.prev')}
            onClick={onPrevious}
            variant={BUTTON_VARIANT.cancel}
            className={styles.prevButton}
          />
          <div className={styles.rightButtons}>
            <Button
              title={t('common.next')}
              onClick={onHandleNext}
              className={styles.button}
            />
          </div>
        </div>
        <DeactivationModal
          open={openModalRefused}
          title={t('materialityAssessment.specifyReasonForRefusal')}
          text={t('materialityAssessment.pleaseSpecifyReasonForRefusal')}
          placeholder={t('materialityAssessment.typeYourMessageHere')}
          className={styles.deactivationModal}
          onReject={onRejectModal}
          onSubmit={onSubmitModal}
          hideLabel
          isLoading={false}
          offValidation
          disabledConfirmBtn
        />
        <DetailsRefusalModal
          open={openModalDetailsRefusal}
          title={t('materialityAssessment.detailsRefusal')}
          onClose={onCloseModalDetailsRefusal}
          person={`${userData?.firstName} ${userData?.lastName}`}
          date={new Date().toISOString()}
          comment={selectedStakeholders.find((item) => item.type === currentId)?.deactivationReason || ''}
        />
      </div>
    </div>
  );
}

export default MaterialityAssessmentStakeholderView;
